import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.7.0_@parcel+watcher@2.3.0_@types+node@20.4.7_encoding@0.1.13_eslint@8.49.0_optionator@_jsiy2g2vv5uyolbeb5xnrtvuny/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}